/**
 * Package Icon URLs - Category-based icons for virtual products
 *
 * To upload the default package image to Azure:
 * 1. Go to Azure Portal > Storage Account > ogestyle-images container
 * 2. Upload package-gift-box.jpg (the red gift box with gold ribbon)
 * 3. The URL will be: https://[storage-account].blob.core.windows.net/ogestyle-images/package-gift-box.jpg
 */

// Default package image URL (Azure Blob Storage)
const DEFAULT_PACKAGE_IMAGE =
  "https://ogestyle.blob.core.windows.net/ogestyle-images/package-gift-box.jpg";

// Fallback placeholder (used if Azure image not uploaded yet)
const FALLBACK_PACKAGE_IMAGE =
  "https://placehold.co/400x300/dc143c/ffffff/png?text=🎁+Package";

export const getPackageIcon = (packageItem) => {
  // If package has custom image, use it
  if (packageItem?.image) {
    return packageItem.image;
  }

  // Use default gift box image from Azure
  return DEFAULT_PACKAGE_IMAGE;
};

/**
 * Get thumbnail icon for mini cart and small displays
 */
export const getPackageThumbnail = (packageItem) => {
  // If package has custom thumbnail, use it
  if (packageItem?.thumbnail || packageItem?.image) {
    return packageItem.thumbnail || packageItem.image;
  }

  // Use default gift box thumbnail from Azure
  return DEFAULT_PACKAGE_IMAGE;
};

/**
 * Check if item is a package (for cart items)
 */
export const isPackage = (item) => {
  return item?.itemType === "package" || item?.type || item?.packageType;
};

/**
 * Get image for any cart item (product or package)
 */
export const getCartItemImage = (item) => {
  if (!item) {
    return "https://placehold.co/80x80/9ca3af/ffffff/png?text=No+Item";
  }

  // Check if it's a package
  if (isPackage(item)) {
    return getPackageThumbnail(item.packageId || item);
  }

  // Product - get first image or placeholder (V2: check masterProductId for images)
  const product = item.productId || item;
  const images = product?.masterProductId?.images || product?.images || [];
  if (images && images.length > 0) {
    return images[0];
  }

  // Default product placeholder
  return "https://placehold.co/80x80/9ca3af/ffffff/png?text=No+Image";
};

export default {
  getPackageIcon,
  getPackageThumbnail,
  isPackage,
  getCartItemImage,
};
